import React, { useState, useEffect } from 'react';
import certificationsData from './data/certifications.json';
import './App.css';
import { useFlashcardState } from './hooks/useFlashcardState';
import { initializeTeams } from './modules/teams/teamsIntegration';
import { loadCertificationData } from './modules/data/dataLoader';
import { 
  handleShuffle, 
  handleNext, 
  handlePrevious, 
  handleReset 
} from './modules/cards/cardManager';
import AppHeader from './modules/ui/AppHeader';
import LoadingComponent from './modules/ui/LoadingComponent';
import FlashcardContainer from './modules/ui/FlashcardContainer';
import WelcomeMessage from './modules/ui/WelcomeMessage';
import AppFooter from './modules/ui/AppFooter';

function App() {
  const {
    currentCardIndex,
    setCurrentCardIndex,
    shuffled,
    setShuffled,
    cards,
    setCards,
    selectedCertification,
    setSelectedCertification,
    setIsTeamsContext,
    isLoading,
    setIsLoading
  } = useFlashcardState();

  const [certifications] = useState(certificationsData);

  useEffect(() => {
    initializeTeams(setIsTeamsContext);
  }, [setIsTeamsContext]);

  const onCertificationSelect = (certification) => {
    loadCertificationData(
      certification, 
      setCards, 
      setSelectedCertification, 
      setCurrentCardIndex, 
      setShuffled, 
      setIsLoading
    );
  };

  const onShuffle = () => {
    handleShuffle(
      shuffled, 
      selectedCertification, 
      cards, 
      setCards, 
      setShuffled, 
      setCurrentCardIndex
    );
  };

  const onNext = () => {
    handleNext(currentCardIndex, cards, setCurrentCardIndex);
  };

  const onPrevious = () => {
    handlePrevious(currentCardIndex, setCurrentCardIndex);
  };

  const onReset = () => {
    handleReset(setCurrentCardIndex);
  };

  return (
    <div className="App">
      <div className="app-container">
        {/* Main Content */}
        <main className="main-content">
          <AppHeader 
            selectedCertification={selectedCertification}
            cards={cards}
            currentCardIndex={currentCardIndex}
            shuffled={shuffled}
            onShuffle={onShuffle}
            onReset={onReset}
            certifications={certifications}
            onCertificationSelect={onCertificationSelect}
          />

          {isLoading ? (
            <LoadingComponent />
          ) : selectedCertification && cards.length > 0 ? (
            <FlashcardContainer 
              cards={cards}
              currentCardIndex={currentCardIndex}
              selectedCertification={selectedCertification}
              onNext={onNext}
              onPrevious={onPrevious}
            />
          ) : (
            <WelcomeMessage />
          )}

          <AppFooter />
        </main>
      </div>
    </div>
  );
}

export default App;
